import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  open: `${NAMESPACE}_ROUTE_SURVEY_MODAL_OPENED`,
  close: `${NAMESPACE}_ROUTE_SURVEY_MODAL_CLOSED`,
  selectSidebarItem: `${NAMESPACE}_ROUTE_SURVEY_MODAL_SELECT_SIDEBAR_ITEM`,

  // toasts
  enqueueToast: `${NAMESPACE}_ROUTE_SURVEY_MODAL_ENQUEUE_TOAST`,
  dequeueToast: `${NAMESPACE}_ROUTE_SURVEY_MODAL_DEQUEUE_TOAST`,

  // fetch surveys
  fetchSurveys: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_SURVEYS`,
  fetchSurveysSucceeded: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_SURVEYS_SUCCEEDED`,
  fetchSurveysFailed: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_SURVEYS_FAILED`,

  // fetch photo albums
  fetchPhotoAlbums: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_PHOTO_ALBUMS`,
  fetchPhotoAlbumsSucceeded: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_PHOTO_ALBUMS_SUCCEEDED`,
  fetchPhotoAlbumsFailed: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_PHOTO_ALBUMS_FAILED`,

  // fetch entity answer
  fetchEntityAnswer: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ENTITY_ANSWER`,
  fetchEntityAnswerSucceeded: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_ENTITY_ANSWER_SUCCEEDED`,
  fetchEntityAnswerFailed: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_ENTITY_ANSWER_FAILED`,

  // fetch signature answer
  fetchSignatureAnswer: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_SIGNATURE_ANSWER`,
  fetchSignatureAnswerSucceeded: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_SIGNATURE_ANSWER_SUCCEEDED`,
  fetchSignatureAnswerFailed: `${NAMESPACE}_ROUTE_SURVEY_MODAL_FETCH_ROUTE_SIGNATURE_ANSWER_FAILED`
};

export const actionCreators = {
  open: ({ routeId, stopId }) => ({ type: actions.open, payload: { routeId, stopId } }),
  close: ({ routeId, stopId }) => ({ type: actions.close, payload: { routeId, stopId } }),
  selectSidebarItem: ({ index, routeId, stopId }) => ({ type: actions.selectSidebarItem, payload: {
    index,
    routeId,
    stopId
  }}),

  // toasts
  enqueueToast: (routeId, stopId, toast) => ({ type: actions.enqueueToast, payload: { routeId, stopId, toast} }),
  dequeueToast: (routeId, stopId, toastKey) => ({ type: actions.dequeueToast, payload: { routeId, stopId, toastKey } }),

  // fetch surveys
  fetchSurveys: (payload) => ({
    type: actions.fetchSurveys, payload
  }),
  fetchSurveysSucceeded: (payload) => ({
    type: actions.fetchSurveysSucceeded, payload
  }),
  fetchSurveysFailed: (payload) => ({
    type: actions.fetchSurveysFailed, payload
  }),

  // fetch photo albums
  fetchPhotoAlbums: (payload) => ({
    type: actions.fetchPhotoAlbums, payload
  }),
  fetchPhotoAlbumsSucceeded: (payload) => ({
    type: actions.fetchPhotoAlbumsSucceeded, payload
  }),
  fetchPhotoAlbumsFailed: (payload) => ({
    type: actions.fetchPhotoAlbumsFailed, payload
  }),

  // fetch entity answer
  fetchEntityAnswer: (routeId, stopId, surveyQuestion) => ({
    type: actions.fetchEntityAnswer, payload: { routeId, stopId, surveyQuestion }
  }),
  fetchEntityAnswerSucceeded: (payload) => ({
    type: actions.fetchEntityAnswerSucceeded, payload
  }),
  fetchEntityAnswerFailed: (payload) => ({
    type: actions.fetchEntityAnswerFailed, payload
  }),

  // fetch signature answer
  fetchSignatureAnswer: (payload) => ({
    type: actions.fetchSignatureAnswer, payload
  }),
  fetchSignatureAnswerSucceeded: (payload) => ({
    type: actions.fetchSignatureAnswerSucceeded, payload
  }),
  fetchSignatureAnswerFailed: (payload) => ({
    type: actions.fetchSignatureAnswerFailed, payload
  })
};

export default {
  actions,
  actionCreators
};
